import listRoutes from './routes'

/* @ngInject */
const listRun = (
  $transitions,
  storageHandler,
  $$dispatch,
  toaster
) => {
  $transitions.onSuccess({
    entering: listRoutes.home.path,
  }, (trans) => {

  })

  $transitions.onBefore({
    from: listRoutes.home.path,
  }, (trans) => {

  })
}

export default listRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/list/list.run.js